import SchoolAutoComplete from 'components/SchoolAutoComplete';
import { useFormik } from 'formik';
import { invert, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import 'react-phone-input-2/lib/style.css';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import { GENDER } from 'utils/constants';
import { titleCaseIfExists } from 'utils/helper';
import { SMKLinks } from 'utils/links';
import * as Yup from 'yup';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Loader from '../../components/Loader';
import useRequest from '../../hooks/useRequest';
import { useRouter } from '../../hooks/useRouter';
import EmergencyContacts from './components/emergencyContacts';

const AddUpdateSchoolClinic = () => {
  const router = useRouter();
  const history = useHistory();
  toast.configure();

  const { query } = router;

  const { schoolClinicDetails, setSchoolClinicDetails } = useState();

  const [getSchoolClinicRequest, { loading: getSchoolClinicLoading }] = useRequest({
    method: 'GET',
    onSuccess: (data) => {
      setSchoolClinicDetails(data);
    },
    onError: (err) => {
      toast.error(
        titleCaseIfExists(err?.message?.message?.replaceAll('_', ' ')) ||
          titleCaseIfExists(err?.message?.replaceAll('_', ' '))
      );
    },
  });

  const [addSchoolClinicRequest, { loading: addSchoolClinicLoading }] = useRequest({
    url: '/school-clinic/admin',
    method: 'POST',
    onSuccess: (data) => {
      history.replace(SMKLinks.SCHOOL_CLINIC_LIST);
      toast.success('Success! School Clinic has been Added.');
    },
    onError: (err) => {
      console.warn('err', err);
      toast.error(
        titleCaseIfExists(err?.message?.message?.replaceAll('_', ' ')) ||
          titleCaseIfExists(err?.message?.replaceAll('_', ' '))
      );
    },
  });

  const [updateSchoolClinicRequest, { loading: updateSchoolClinicLoading }] = useRequest({
    method: 'PUT',
    onSuccess: (data) => {
      window.location.reload();
      toast.success('Success! School Clinic has been Added.');
    },
    onError: (err) => {
      toast.error(
        titleCaseIfExists(err?.message?.message?.replaceAll('_', ' ')) ||
          titleCaseIfExists(err?.message?.replaceAll('_', ' '))
      );
    },
  });

  useEffect(() => {
    if (!isEmpty(query?.id)) {
      getSchoolClinicRequest({
        url: `/school-clinic/admin/${query?.id}`,
      });
    }
  }, [query]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      school: null,
      name: '',
      email: '',
      phoneNumber: '',
      adminName: '',
      adminEmail: '',
      adminPhoneNumber: '',
      adminBio: '',
      adminGender: '',
      emergencyContactInfo: null,
    },

    onSubmit(values) {
      const payload = {
        schoolId: values?.school?.id,
        name: values?.name,
        email: values?.email,
        phoneNumber: values?.phoneNumber,
        address: {
          phoneNumber: values?.school?.address?.phoneNumber,
          isBillingAddress: values?.school?.address?.isBillingAddress || false,
          line1: values?.school?.address?.line1 || '',
          line2: values?.school?.address?.line2 || '',
          subArea: values?.school?.address?.subArea?.displayName,
          city: values?.school?.address?.city?.displayName,
          country: values?.school?.address?.country?.displayName,
          postalCode: values?.school?.address?.postalCode,
          landmark: values?.school?.address?.landmark,
          location: values?.school?.address?.location,
        },
        owner: {
          name: values?.adminName,
          email: values?.adminEmail,
          phoneNumber: values?.adminPhoneNumber,
          bio: values?.adminBio,
          gender: values?.adminGender,
        },
        emergencyContactInfo: values?.emergencyContactInfo,
      };

      if (!isEmpty(query?.id)) {
        updateSchoolClinicRequest({
          url: `/schoolClinic/admin/${query?.id}`,
          data: payload,
        });
      } else {
        addSchoolClinicRequest({ data: payload });
      }
    },
    validationSchema: Yup.object().shape({
      school: Yup.object()
        .nullable()
        .required('School is requried'),
      name: Yup.string().required('Name is requried'),
      email: Yup.string().required('Email is requried'),
      phoneNumber: Yup.string().required('Please Select a Phone Number'),
      adminName: Yup.string().required('Please Select a Admin Name'),
      adminEmail: Yup.string().required('Please Select a Admin Email'),
      adminPhoneNumber: Yup.string().required('Please Select a Admin Phone Number'),
    }),
  });

  return (
    <div className="page-content">
      <Loader isActive={getSchoolClinicLoading || addSchoolClinicLoading || updateSchoolClinicLoading} />
      <Container fluid>
        <Breadcrumbs
          title={'School Clinic'}
          breadcrumbItem={`${isEmpty(query?.id) ? 'Add' : 'Update'} School Clinic`}
        />

        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={9}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <FormGroup className="mb-4">
                        <Label for="school" className="form-label  ">
                          School
                        </Label>
                        <SchoolAutoComplete
                          isNotClearable={true}
                          selectedSchool={formik.values.school}
                          onSelectSchool={(school) => {
                            formik.setFieldValue('school', school);
                            formik.setFieldValue('name', school?.displayName + ' Clinic');
                          }}
                        />
                        {formik.touched.school && (
                          <div className="invalid-feedback d-block">{formik.errors.school}</div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md={12}>
                      <FormGroup className="mb-4">
                        <Label htmlFor="name" className="form-label  ">
                          Name
                        </Label>
                        <Input
                          id="name"
                          type="text"
                          className="form-control"
                          placeholder=" Name"
                          invalid={!!(formik.touched.name && formik.errors.name)}
                          {...formik.getFieldProps('name')}
                        />
                        <FormFeedback>{formik.errors.name}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup className="mb-4">
                        <Label htmlFor="email" className="form-label  ">
                          Email
                        </Label>
                        <Input
                          id="email"
                          type="text"
                          className="form-control"
                          placeholder="Email"
                          invalid={!!(formik.touched.email && formik.errors.email)}
                          {...formik.getFieldProps('email')}
                        />
                        <FormFeedback>{formik.errors.email}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup className="mb-4">
                        <Label for="phoneNumber" className="form-label  ">
                          Phone Number
                        </Label>
                        <Input
                          id="phoneNumber"
                          type="number"
                          className="form-control"
                          placeholder="Phone Number..."
                          invalid={!!(formik.touched.phoneNumber && formik.errors.phoneNumber)}
                          {...formik.getFieldProps('phoneNumber')}
                        />
                        <FormFeedback>{formik.errors.phoneNumber}</FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="mb-5">
                <CardBody>
                  <div className="bg-light p-4 rounded-2 mb-4">
                    <EmergencyContacts
                      formik={formik}
                      keyName={'emergencyContactInfo'}
                      label={'Emergency Contact Info'}
                    />
                  </div>
                </CardBody>
              </Card>

              <div className="mb-5 pb-5">
                <Card>
                  <CardBody>
                    <h4 className="border-bottom pb-3 mb-4">Admin User Details</h4>
                    <Row>
                      <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label htmlFor="adminName" className="form-label  ">
                            Name
                          </Label>
                          <Input
                            id="adminName"
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            invalid={!!(formik.touched.adminName && formik.errors.adminName)}
                            {...formik.getFieldProps('adminName')}
                          />
                          <FormFeedback>{formik.errors.adminName}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label htmlFor="adminBio" className="form-label  ">
                            Bio
                          </Label>
                          <Input
                            id="adminBio"
                            type="text"
                            className="form-control"
                            placeholder="Bio"
                            invalid={!!(formik.touched.adminBio && formik.errors.adminBio)}
                            {...formik.getFieldProps('adminBio')}
                          />
                          <FormFeedback>{formik.errors.adminBio}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md={12}>
                        <FormGroup className="mb-4">
                          <Label htmlFor="adminEmail" className="form-label  ">
                            Email
                          </Label>
                          <Input
                            id="adminEmail"
                            type="text"
                            className="form-control"
                            placeholder="Email"
                            invalid={!!(formik.touched.adminEmail && formik.errors.adminEmail)}
                            {...formik.getFieldProps('adminEmail')}
                          />
                          <FormFeedback>{formik.errors.adminEmail}</FormFeedback>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label for="adminPhoneNumber" className="form-label  ">
                            Phone Number
                          </Label>
                          <Input
                            id="adminPhoneNumber"
                            type="number"
                            className="form-control"
                            placeholder="Phone Number..."
                            invalid={!!(formik.touched.adminPhoneNumber && formik.errors.adminPhoneNumber)}
                            {...formik.getFieldProps('adminPhoneNumber')}
                          />
                          <FormFeedback>{formik.errors.adminPhoneNumber}</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup className="mb-4">
                          <Label htmlFor="adminGender" className="form-label  ">
                            Gender
                          </Label>
                          <Select
                            name="adminGender"
                            id="adminGender"
                            placeholder="Please select an option"
                            options={Object.entries(GENDER).map(([key, value]) => ({
                              value,
                              label: titleCaseIfExists(key),
                            }))}
                            onChange={(val) => formik.setFieldValue('adminGender', val?.value)}
                            value={
                              formik.values.adminGender && {
                                label: titleCaseIfExists(invert(GENDER)[formik.values.adminGender]),
                                value: formik.values.adminGender,
                              }
                            }
                          />
                          {formik.touched.adminGender && (
                            <div className="invalid-feedback d-block">{formik.errors.adminGender}</div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </div>
            </Col>
            <Col md={3}>
              <Card>
                <CardBody>
                  <Button type="submit" color="primary" className="mb-3 w-100">
                    Save
                  </Button>
                  <Button
                    className="w-100"
                    color="light"
                    onClick={() => {
                      history.replace(SMKLinks.SCHOOL_CLINIC_LIST);
                    }}>
                    Cancel
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};

export default AddUpdateSchoolClinic;
